import { formatDocumentTypeLabel } from './documentTypes';

export const REPROCESS_DOCUMENT_AS = `
  mutation ReprocessDocumentAs($input: ReprocessDocumentAsInput!) {
    reprocessDocumentAs(input: $input) {
      source_document_id
      redirect_target_doc_type
      redirect_target_document_id
      status
      message
    }
  }
`;

export async function reprocessDocumentAs(callApi, documentId, targetDocType) {
  const data = await callApi(REPROCESS_DOCUMENT_AS, {
    input: {
      document_id: documentId,
      target_doc_type: targetDocType,
    },
  });
  return data?.reprocessDocumentAs;
}

export function reprocessToastMessage(result, targetDocType) {
  const tipo = formatDocumentTypeLabel(result?.redirect_target_doc_type || targetDocType);
  const status = result?.status;
  if (status === 'QUEUED') {
    return `Reproceso iniciado como ${tipo}.`;
  }
  if (status === 'ALREADY_EXISTS') {
    return result?.message || `Ya existe un documento con ese contenido como ${tipo}`;
  }
  return result?.message || 'No se pudo iniciar el reproceso';
}
